var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    fill: "#42424E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.668 3.33464H14.0263L12.993 2.20964C12.8377 2.03913 12.6485 1.90289 12.4376 1.80962C12.2267 1.71636 11.9986 1.66811 11.768 1.66797H8.23464C7.76797 1.66797 7.31797 1.86797 7.0013 2.20964L5.9763 3.33464H3.33464C2.41797 3.33464 1.66797 4.08464 1.66797 5.0013V15.0013C1.66797 15.918 2.41797 16.668 3.33464 16.668H16.668C17.5846 16.668 18.3346 15.918 18.3346 15.0013V5.0013C18.3346 4.08464 17.5846 3.33464 16.668 3.33464ZM10.0013 14.168C7.7013 14.168 5.83464 12.3013 5.83464 10.0013C5.83464 7.7013 7.7013 5.83463 10.0013 5.83463C12.3013 5.83463 14.168 7.7013 14.168 10.0013C14.168 12.3013 12.3013 14.168 10.0013 14.168Z",
    fill: "#42424E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.3bfeb90e932d205c4da38a2db31720e5.svg";
export { ForwardRef as ReactComponent };